import { render, staticRenderFns } from "./SlotModal.vue?vue&type=template&id=854661c8&scoped=true"
import script from "./SlotModal.vue?vue&type=script&lang=js"
export * from "./SlotModal.vue?vue&type=script&lang=js"
import style0 from "./SlotModal.vue?vue&type=style&index=0&id=854661c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854661c8",
  null
  
)

export default component.exports